import { DropdownOptionType } from "@/types/dropdownOption";

export const EmploymentMonthDropdownOptionsList: DropdownOptionType[] = [
  {
    id: 1,
    text: "January",
  },
  {
    id: 2,
    text: "February",
  },
  {
    id: 3,
    text: "March",
  },
  {
    id: 4,
    text: "April",
  },
  {
    id: 5,
    text: "May",
  },
  {
    id: 6,
    text: "June",
  },
  {
    id: 7,
    text: "July",
  },
  {
    id: 8,
    text: "August",
  },
  {
    id: 9,
    text: "September",
  },
  {
    id: 10,
    text: "October",
  },
  {
    id: 11,
    text: "November",
  },
  {
    id: 12,
    text: "December",
  },
];

export const NoticePeriodDropdownOptionsList: DropdownOptionType[] = [
  {
    id: 1,
    text: "Serving Notice Period",
  },
  {
    id: 2,
    text: "Immediately available",
  },
  {
    id: 3,
    text: "15 days",
  },
  {
    id: 4,
    text: "30 days",
  },
  {
    id: 5,
    text: "45 days",
  },
  {
    id: 6,
    text: "2 months",
  },
  {
    id: 7,
    text: "3 months",
  },
  {
    id: 8,
    text: "6 months",
  },
];

export const CurrentlyWorkingCheckbox = [
  {
    value: "isCurrentlyWorking",
    id: "checkbox",
    displayName: "Currently working here",
  },
];

export const HideSalaryCheckbox = [
  {
    value: "hideSalary",
    id: "hideSalary",
    displayName: "Hide my salary from potential employers",
  },
];

export const HideSalaryNoticeCheckbox = [
  {
    value: "hideNoticeSalary",
    id: "hideNoticeSalary",
    displayName: "Hide my salary from potential employers",
  },
];

export const SalaryModeOptions = [
  {
    id: "en:69a8f26e-222e-11e9-9330-1418775c7275",
    uuid: "69a8f26e-222e-11e9-9330-1418775c7275",
    language: "en",
    enabled: true,
    orderBy: 10,
    name: "Monthly",
    type: "SALARY_MODE",
    kiwiId: 1,
    nameAndType: "monthly_salary_mode",
    score_source: "ELASTIC",
  },
  {
    id: "en:7cad9bf9-222e-11e9-9330-1418775c7275",
    uuid: "7cad9bf9-222e-11e9-9330-1418775c7275",
    language: "en",
    enabled: true,
    orderBy: 20,
    name: "Annually",
    type: "SALARY_MODE",
    kiwiId: 2,
    nameAndType: "annually_salary_mode",
    score_source: "ELASTIC",
  },
];

export const LOWER_THRESHOLD = 100000;
export const UPPER_THRESHOLD = 20000000;
